import { useState } from "react";
import { useNavigate } from "react-router-dom";
import imgWhiteLogo1 from "../../assets/2ccda97ecaa4b401fe79d7f0575e654788a45c27.png";

function Logo() {
  return (
    <div className="flex items-center gap-3">
      <img src={imgWhiteLogo1} alt="Project Ontario" className="h-8 w-8" />
      <div className="text-white font-black tracking-tight leading-5">
        <div>PROJECT</div>
        <div>ONTARIO</div>
      </div>
    </div>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 56; // 14 * 4 = 56px (h-14)
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="bg-[#00499d] w-full border-b border-white/20 fixed top-0 left-0 right-0 z-50">
      <div className="max-w-[1200px] mx-auto px-4 h-14 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-6 text-white font-bold text-sm">
          <a onClick={(e) => { e.preventDefault(); scrollToSection('events'); }} href="#events" className="hover:opacity-70 transition-opacity cursor-pointer">Events</a>
          <a onClick={(e) => { e.preventDefault(); scrollToSection('issues'); }} href="#issues" className="hover:opacity-70 transition-opacity cursor-pointer">Issues</a>
          <a onClick={(e) => { e.preventDefault(); scrollToSection('opeds'); }} href="#opeds" className="hover:opacity-70 transition-opacity cursor-pointer">Op-Eds</a>
          <a onClick={(e) => { e.preventDefault(); scrollToSection('press'); }} href="#press" className="hover:opacity-70 transition-opacity cursor-pointer">Press</a>
          <a onClick={(e) => { e.preventDefault(); scrollToSection('about'); }} href="#about" className="hover:opacity-70 transition-opacity cursor-pointer">About</a>
          <button
            onClick={() => navigate('/survey')}
            className="hover:opacity-70 transition-opacity cursor-pointer"
            type="button"
          >
            Survey
          </button>
        </nav>
        <div className="hidden md:flex items-center gap-2">
          <button onClick={() => scrollToSection('signup')} className="text-white border border-white rounded-full px-3 py-1 text-sm hover:bg-white/10 transition-colors cursor-pointer">Sign Up</button>
          <button onClick={() => navigate('/donate')} className="bg-white text-[#00499d] rounded-full px-3 py-1 text-sm font-bold hover:scale-105 transition-transform">Donate</button>
        </div>
        <button
          className="md:hidden text-white p-2 hover:bg-white/10 rounded transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {open ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/20 bg-[#00499d] animate-in slide-in-from-top duration-200">
          <div className="px-4 py-4 flex flex-col gap-3 text-white">
            <a href="#events" onClick={(e) => { e.preventDefault(); scrollToSection('events'); setOpen(false); }} className="py-2 hover:opacity-70 transition-opacity cursor-pointer">Events</a>
            <a href="#issues" onClick={(e) => { e.preventDefault(); scrollToSection('issues'); setOpen(false); }} className="py-2 hover:opacity-70 transition-opacity cursor-pointer">Issues</a>
            <a href="#opeds" onClick={(e) => { e.preventDefault(); scrollToSection('opeds'); setOpen(false); }} className="py-2 hover:opacity-70 transition-opacity cursor-pointer">Op-Eds</a>
            <a href="#press" onClick={(e) => { e.preventDefault(); scrollToSection('press'); setOpen(false); }} className="py-2 hover:opacity-70 transition-opacity cursor-pointer">Press</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); setOpen(false); }} className="py-2 hover:opacity-70 transition-opacity cursor-pointer">About</a>
            <button
              onClick={() => { navigate('/survey'); setOpen(false); }}
              className="text-left py-2 hover:opacity-70 transition-opacity cursor-pointer"
              type="button"
            >
              Survey
            </button>
            <div className="flex flex-col gap-2 pt-3 border-t border-white/20">
              <button onClick={() => { scrollToSection('signup'); setOpen(false); }} className="text-white border border-white rounded-full px-4 py-2 text-sm hover:bg-white/10 transition-colors cursor-pointer">Sign Up</button>
              <button onClick={() => navigate('/donate')} className="bg-white text-[#00499d] rounded-full px-4 py-2 text-sm font-bold hover:opacity-90 transition-opacity">Donate</button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
